export default __webpack_public_path__ + "static/media/score_increase.bf568830.mp3";